"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeerManager = void 0;
const __1 = require("..");
const StorageManager_1 = require("./StorageManager");
class PeerManager {
    constructor(storage) {
        this.storageManager = new StorageManager_1.StorageManager(storage, __1.StorageKey.TRANSPORT_P2P_PEERS);
    }
    async hasPeer(publicKey) {
        return (await this.getPeer(publicKey)) ? true : false;
    }
    async getPeers() {
        return this.storageManager.getAll();
    }
    async getPeer(publicKey) {
        return this.storageManager.getOne((peer) => peer.publicKey === publicKey);
    }
    async addPeer(peerInfo) {
        return this.storageManager.addOne(peerInfo, (peer) => peer.publicKey === peerInfo.publicKey);
    }
    async removePeer(publicKey) {
        return this.storageManager.remove((peer) => peer.publicKey === publicKey);
    }
    async removePeers(publicKeys) {
        return this.storageManager.remove((peer) => publicKeys.includes(peer.publicKey));
    }
    async removeAllPeers() {
        return this.storageManager.removeAll();
    }
}
exports.PeerManager = PeerManager;
//# sourceMappingURL=PeerManager.js.map